import { formatCurrency } from 'utils/CurrencyUtils';
import { useGetOrderDetailById } from 'shared/hooks';

import type { CustomizationId, OrderId, ProductId } from 'shared/domain';

export function useSubstitutionFlowToppingHOC(props: Props) {
  const { orderId, orderProductId, customizationId } = props;

  const { data: order } = useGetOrderDetailById(orderId);

  const sfState = order.substitutionFlowState;

  const stockoutItem = sfState?.toppings?.find(
    c => c.orderProductId === orderProductId && c.id === customizationId,
  );

  const replacementItem = stockoutItem?.replacements?.[0];

  const hasReplacement = sfState?.status === 'accepted' && !!replacementItem;

  const price =
    order.products
      .filter(p => p.orderProductId === orderProductId)[0]
      ?.toppings.find(t => t.id === customizationId)?.price.total ?? 0;

  return {
    hasReplacement,
    stockoutItem,
    replacementItem,
    formatedPrice: formatCurrency(price),
  };
}

interface Props {
  orderId: OrderId;
  orderProductId: ProductId;
  customizationId: CustomizationId;
}
